module.exports = __webpack_public_path__ + "assets/img/peo1.685d3705.png";